var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"main"},[_c('span',{style:(_vm.styleName),on:{"click":function($event){return _vm.fullscreenToggel()}}},[_vm._v(_vm._s(_vm.flag?'退出全屏':'全屏'))])])
}
var staticRenderFns = []

export { render, staticRenderFns }